<template>
  <bar-chart :chartdata="chartdata"/>
</template>

<script>
import BarChart from '@/components/charts/bar'

export default {
  name: 'BackupsByAccount',
  components: {
    BarChart
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      chartdata: null
    }
  },
  methods: {
    fillchartdata: function () {
      var labels = []
      var accounts = {}

      for (const type in this.data) {
        for (const resource in this.data[type]['resources']) {
          var account = this.data[type]['resources'][resource]['account_id']

          if (!accounts.hasOwnProperty(account)) {
            accounts[account] = {}
          }

          if (!accounts[account].hasOwnProperty(type)) {
            accounts[account][type] = 0
          }

          accounts[account][type] += this.data[type]['resources'][resource]['total']
        }
      }

      var dataset = {
        ami: [],
        rds: [],
        aurora: [],
        ebs: [],
        redshift: [],
        documentdb: [],
        s3: []
      }

      for (const account in accounts) {
        labels.push(account)
        for (const type in dataset) {
          if (accounts[account].hasOwnProperty(type)) {
            dataset[type].push(accounts[account][type])
          } else {
            dataset[type].push(0)
          }
        }
      }

      this.chartdata = {
        labels: labels,
        datasets: [
          {
            label: 'ebs',
            backgroundColor: '#ffd166',
            data: dataset.ebs
          },
          {
            label: 'redshift',
            backgroundColor: '#ff8c66',
            data: dataset.redshift
          },
          {
            label: 'ami',
            backgroundColor: '#ef476f',
            data: dataset.ami
          },
          {
            label: 'rds',
            backgroundColor: '#06d6a0',
            data: dataset.rds
          },
          {
            label: 's3',
            backgroundColor: '#66d9ff',
            data: dataset.s3
          },
          {
            label: 'aurora',
            backgroundColor: '#118ab2',
            data: dataset.aurora
          },
          {
            label: 'documentdb',
            backgroundColor: '#b366ff',
            data: dataset.documentdb
          }
        ]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/BackupsByAccount.vue